import moment from 'moment';
import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

class Forms extends React.Component {
    constructor(props) {
        super(props);
        this.state = { show: false };
    }

    render() {
        return (
            <Form.Group>
                <Form.Label>{this.props.title}</Form.Label>
                <Form.Group>
                    <div className="inline_input_box">
                        <input
                            type="text"
                            placeholder="YYYY.MM.DD"
                            id="nCal01"
                            value={this.props.value}
                            onChange={e => {
                                // this.props.onChange(e.target.value);
                                // this.setState({ show: false });
                            }}
                            disabled={this.props.disabled}
                        />
                        <span className="ib" onClick={e => !this.props.disabled && this.setState({ show: !this.state.show })}>
                            <i className="feather icon-calendar"></i>
                        </span>

                        {/* 캘린더 선택 */}
                        <div className={!this.props.disabled && this.state.show ? 'pop_cal_nor show' : 'pop_cal_nor'}>
                            <Calendar
                                date={this.props.value.length === 10 ? new Date(this.props.value) : new Date()}
                                onChange={date => {
                                    this.props.onChange(moment(date).format('YYYY.MM.DD'));
                                    this.setState({ show: false });
                                }}
                            />
                        </div>
                    </div>
                </Form.Group>
            </Form.Group>
        );
    }
}

export default Forms;
